// extracted by css-extract-rspack-plugin
export default {"fullContainer":"index__fullContainer___Cl0jA","container":"index__container___OPBdi","content":"index__content___sMzJV","title":"index__title___JbGpI","bar":"index__bar___rK0ai"};